import * as React from "react";
import { BreadCrumbsRenderer } from "..";
import { PageHeader } from "antd";
import { Route } from "antd/es/breadcrumb/Breadcrumb";
//styles
import "./Layout.less";

type PageHeaderProps = {
  show: boolean;
  title: string;
  extra?: any;
  routes?: Route[];
  tags?: React.ReactElement;
};
type ContentProps = {
  pageHeader?: PageHeaderProps | boolean;
  children?: React.ReactNode;
};

export default function Content({
  pageHeader: propsPageHeader = false,
  children: propsChildren,
}: React.PropsWithChildren<ContentProps>) {
  if (typeof propsPageHeader === "boolean") {
    propsPageHeader = {
      show: propsPageHeader,
      title: "Default title",
    };
  }
  const {
    show: propsPageHeaderShow = true,
    title: propsPageHeaderTitle = "Title",
    routes: propsPageHeaderRoutes = [],
    extra: propsPageHeaderExtra = [],
    tags: propsPageHeaderTags = [],
  } = propsPageHeader;

  return (
    <section className="content">
      <section className="content-page">
        <>
          {propsPageHeaderShow && (
            <PageHeader
              className="pageheader"
              title={propsPageHeaderTitle}
              breadcrumb={{
                routes: propsPageHeaderRoutes,
                itemRender: BreadCrumbsRenderer,
              }}
              extra={propsPageHeaderExtra}
              tags={propsPageHeaderTags}
            />
          )}
          {propsChildren}
        </>
      </section>
    </section>
  );
}
